import { useContext } from 'react';
import { Band } from '@/components/Modules/Band/Band';
import { StructuredText, Image } from 'react-datocms';
import type { LoanHeroFragment } from '@/utils/dato/generated';
import { RepresentativeApr } from '@/components/RepresentativeApr';
import { CalculatorContext } from '@/components/Calculator/Context';
import { customNodeRules, renderBlock } from '@/components/structuredText';
import { isEmptyDocument, type Document } from 'datocms-structured-text-utils';

const LoanHero = ({ representativeExample, loanHeroImage, copy }: LoanHeroFragment) => {
  const { channel } = useContext(CalculatorContext);

  return (
    <Band data-automation="ZA.loanHero" className="loan-hero-module">
      <div className="flex flex-wrap md:flex-row md:flex-nowrap justify-start items-start">
        <div className="md:max-w-1/2">
          <div className="lead display-heading text-center md:text-left">
            {copy ? (
              <div
                className="[&_.representative-apr-module]:text-left [&_.band]:p-0
                md:[&_.representative-apr-module]:hidden"
              >
                <StructuredText
                  data={{ value: copy.value as Document, blocks: copy.loanHeroBlocks }}
                  customNodeRules={customNodeRules}
                  renderBlock={renderBlock}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="relative md:max-w-1/2">
          {loanHeroImage?.responsiveImage ? (
            <div className="hidden md:block pl-13">
              <Image data={loanHeroImage.responsiveImage} className="mx-auto z-2" priority={true} />
            </div>
          ) : null}

          {representativeExample?.value && !isEmptyDocument(representativeExample?.value) ? (
            <div
              className="relative clear-right bg-base-100 z-1 -mt-[120px] pt-[160px] pb-[64px]
md:mt-[30px] md:pl-[104px] md:pt-[40px] md:pb-[40px]
xl:-mt-[80px] xl:pt-[130px] xl:pb-[60px]
md:[&_.representative-apr-module]:max-w-[300px]"
            >
              <div
                className="
      absolute inset-y-0 right-full top-0 bottom-0
      w-[9999px] bg-base-100
      md:rounded-l-[12px]
      md:w-[calc(-100%+958px)]
      lg:w-[calc(-100%+1222px)]
    "
              ></div>
              <RepresentativeApr
                copy={representativeExample.value as Document}
                className="small hidden md:block"
                channel={channel}
              />
              <div
                className="
      absolute inset-y-0 left-full top-0 bottom-0
      w-[9999px] bg-base-100
      lg:w-[22px] lg:rounded-r-[12px]
    "
              ></div>
            </div>
          ) : null}
        </div>
      </div>
    </Band>
  );
};

export default LoanHero;
